import { object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  ack_id: string().required(),
  error: string().required(),
});

/**
 * SystemErrorEvent
 *
 * - Esse evento é enviado pelo servidor em resposta a um evento enviado pelo cliente que falhou.
 * - O servidor irá enviar esse evento com o motivo do erro.
 */
export class SystemErrorEvent extends CreateCommand(RealtimeEventType.SystemError, SCHEMA) {}
